/**
 * Trigger a browser download for a blob returned by an export endpoint.
 *
 * Shared by the specialized-agent and workflow export services (and the future
 * combined-view export). Prefers the server-provided Content-Disposition
 * filename, falling back to the supplied name.
 */
export function triggerBlobDownload(
  blob: Blob,
  contentDisposition: string | undefined,
  fallbackName: string
): void {
  const filename = contentDisposition?.match(/filename="?(.+?)"?$/)?.[1] ?? fallbackName;

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
